import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';
const ProductSearchCount = t0 => {
  const $ = _c(9);
  const {
    title,
    indexClick,
    selectedOption,
    id
  } = t0;
  const {
    results
  } = useInstantSearch();
  const isSelected = selectedOption === id;
  const count = results?.nbHits || 0;
  let t1;
  if ($[0] !== id || $[1] !== indexClick) {
    t1 = () => {
      indexClick(id);
    };
    $[0] = id;
    $[1] = indexClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleIndexClick = t1;
  let t2;
  if ($[3] !== isSelected) {
    t2 = classNames("w-full bg-white text-center lg:text-left", {
      "font-bold": isSelected
    });
    $[3] = isSelected;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${title} (${count})`;
  let t4;
  if ($[5] !== handleIndexClick || $[6] !== t2 || $[7] !== t3) {
    t4 = <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand"><button type="button" className={t2} onClick={handleIndexClick}>{t3}</button></div>;
    $[5] = handleIndexClick;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ProductSearchCount;